import { QueryParamKeys } from "@sg-protect/components";
import { mergeFilters } from "@sg-protect/core";
import { usePaths } from "../../paths.ts";
import { useCanOpenActivityLog } from "./useCanOpenActivityLog.ts";

export function useOperationActivityLogHref(bulkId: string, variant: "running" | "failed") {
    const paths = usePaths();
    const canOpenActivityLog = useCanOpenActivityLog();

    if (!canOpenActivityLog) {
        return undefined;
    }

    const filter = mergeFilters([`bulkActionId eq ${bulkId}`, variant === "failed" ? "status eq 'failed'" : undefined]);
    const params = new URLSearchParams({ [QueryParamKeys.Filter]: filter ?? "" });

    return `${paths.activityLog}?${params.toString()}`;
}
